import { Box, Typography } from "@mui/material";
import { InputNumberSpinner } from "../../inputComponents/InputNumberSpinner";
import { RadioButton } from "../../inputComponents/RadioButton";
import { FormikContextType, getIn } from "formik";
import { limitsStateValues } from "../../../types/componentTypes/limits";

interface CalendarCycleLimitProps {
    formik: FormikContextType<limitsStateValues>;
    limitsField: string;
}

const CalendarCycleLimit = ({ formik, limitsField }: CalendarCycleLimitProps) => {
    const handlePeriodChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === 'week') {
            formik.setFieldValue(`${limitsField}.firstDayOfWeek`, 'monday');
            return;
        }

        formik.setFieldValue(`${limitsField}.firstDayOfWeek`, '');
    }

    return (
        <Box mt={1}>
            <InputNumberSpinner
                fieldName={`${limitsField}.limit`}
                label={'Limit'}
                incrementValue={1}
                minValue={1}
            />
            <RadioButton
                labelVariant='body2'
                formik={formik}
                values={[
                    { value: 'week', label: 'Week' },
                    { value: 'month', label: 'Month' },
                    { value: 'year', label: 'Year' },
                ]}
                radioGroupName={`${limitsField}.period`}
                onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue(`${limitsField}.period`, value);
                }}
                customAction={handlePeriodChanged}
                data-testId={'calendarCycleLimit-period-radio-button'}
            />
            {
                getIn(formik.values, `${limitsField}.period`) === 'week' &&
                <Box mt={1}>
                    <Typography variant='body1'>
                        First Day of the Week
                    </Typography>
                    <RadioButton
                        row
                        labelVariant='body2'
                        formik={formik}
                        values={[
                            { value: 'monday', label: 'Monday' },
                            { value: 'sunday', label: 'Sunday' },
                        ]}
                        radioGroupName={`${limitsField}.firstDayOfWeek`}
                        onChange={(e) => {
                            const value = e.target.value;
                            formik.setFieldValue(`${limitsField}.firstDayOfWeek`, value);
                        }}
                        data-testId={'calendarCycleLimit-firstDayOfWeek-radio-button'}
                    />
                </Box>
            }
        </Box>

    );
}

export { CalendarCycleLimit };
